import {Action} from '@ngrx/store';
import {BijbError} from '../../../models/bijb-error';

export class DeleteChatsErrorAction implements Action {
  public static readonly type = 'DeleteChatsErrorAction';

  constructor(public error: BijbError) {
  }

  public type = DeleteChatsErrorAction.type;
}
